import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {GameUserInfo} from '../../models/user/game-user-info.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GameAccountService {
  private readonly baseUrl = `${environment.backend.url}/api/user/v1`;

  constructor(private readonly http: HttpClient) { }

  /**
   * Fetches the game accounts associated with the user.
   *
   * @return {Observable<GameUserInfo[]>} An observable that emits the game user information.
   */
  public getGameAccounts(): Observable<GameUserInfo[]> {
    return this.http.get<GameUserInfo[]>(`${this.baseUrl}/conquer/accounts`);
  }

  /**
   * Changes the password for a game account.
   *
   * @param recaptchaToken
   * @param accountId The ID of the account to change the password for
   * @param password The new password
   * @param confirmPassword Confirmation of the new password
   * @return {Observable<any>} An observable that emits the response
   */
  public changePassword(recaptchaToken: string, accountId: number, password: string, confirmPassword: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/conquer/account/change-password`, {
      accountId,
      password,
      confirmPassword
    }, {
      headers: {
        'x-recaptcha-token': recaptchaToken,
      }
    });
  }

  /**
   * Deletes a game account.
   *
   * @param recaptchaToken
   * @param accountId The ID of the account to delete
   * @return {Observable<any>} An observable that emits the response
   */
  public deleteAccount(recaptchaToken: string, accountId: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/conquer/account/${accountId}`, {
      headers: {
        'x-recaptcha-token': recaptchaToken,
      }
    });
  }

  /**
   * Registers a new game account.
   *
   * @param recaptchaToken
   * @param userName The username for the new account
   * @param password The password for the new account
   * @param confirmPassword Confirmation of the password
   * @return {Observable<any>} An observable that emits the response
   */
  public registerAccount(recaptchaToken: string, userName: string, password: string, confirmPassword: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/conquer/register`, {
      userName,
      password,
      confirmPassword
    }, {
      headers: {
        'x-recaptcha-token': recaptchaToken,
      }
    });
  }
}
